var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7713 11.1046C11.2496 11.6263 10.252 12.6239 9.4139 13.462C8.63285 14.243 7.36735 14.2431 6.58631 13.462C5.76391 12.6396 4.78317 11.6589 4.22885 11.1046C2.14605 9.02177 2.14605 5.64489 4.22885 3.5621C6.31164 1.4793 9.68852 1.4793 11.7713 3.5621C13.8541 5.64489 13.8541 9.02177 11.7713 11.1046Z",
    stroke: "#D22268",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 7.33333C10.0001 8.4379 9.10465 9.33333 8.00008 9.33333C6.89551 9.33333 6.00008 8.4379 6.00008 7.33333C6.00008 6.22876 6.89551 5.33333 8.00008 5.33333C9.10465 5.33333 10.0001 6.22876 10.0001 7.33333Z",
    stroke: "#D22268",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/Location Pin.9c17b40998a687f8f1b183ccee7a9832.svg";
export { ForwardRef as ReactComponent };